import { render, staticRenderFns } from "./ProductionItem.vue?vue&type=template&id=7fdcc5f5&scoped=true&"
import script from "./ProductionItem.vue?vue&type=script&lang=js&"
export * from "./ProductionItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductionItem.vue?vue&type=style&index=0&id=7fdcc5f5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdcc5f5",
  null
  
)

export default component.exports